import restauranttypesService from '../../services/restauranttypes'

const state = {
    restauranttypes: []
}

// getters
const getters = {
  
}

// actions
const actions = {
  async getRestaurantTypesAction(context) {
    await restauranttypesService.getAllRestaurantTypes()
                            .then( data => 
                              { context.commit('setRestaurantTypesState', data) });  
  }
  
}

// mutations
const mutations = {
  setRestaurantTypesState(state, restauranttypes) {
    state.restauranttypes = restauranttypes;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}